export class TenantInfo {
  tenantID: string;
  tenantName: string;
}
